import React, { useState, useEffect, useRef } from 'react';

export default function Splash({ onDone }) {
  const [fading, setFading] = useState(false);
  const videoRef = useRef(null);
  const timerRef = useRef(null);

  const finish = () => {
    if (fading) return;
    setFading(true);
    setTimeout(() => onDone(), 600);
  };

  useEffect(() => {
    // Auto-finish after 5.5 seconds regardless
    timerRef.current = setTimeout(finish, 6500);
    return () => clearTimeout(timerRef.current);
  }, []);

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'linear-gradient(135deg,#E55100,#FF6B00,#FF9933)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      opacity: fading ? 0 : 1,
      transition: 'opacity 0.6s ease',
    }}>
      {/* Full screen video */}
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        onEnded={finish}
        style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover' }}
      >
        <source src="/images/loading-video.mp4" type="video/mp4"/>
      </video>

    </div>
  );
}